// eslint-disable-next-line import/no-cycle
import { StoryblokComponent } from '@storyblok/react';

import Footer from '@/components/layouts/Footer';
import { GalleryOverlay } from '@/components/layouts/GalleryGrid';
import Header from '@/components/layouts/Header';
import Hero from '@/components/layouts/Hero';

const Project = ({
  story,
  blok,
  settingsHeader,
  settingsFooter,
  settingsFooterProject,
}) => {
  return (
    <>
      <Hero story={story} blok={blok} type="project">
        <Header theme={'light'} settingsHeader={settingsHeader} />
      </Hero>
      <main role="main" id="main">
        {blok.body
          ? blok.body.map((blk) => (
              <StoryblokComponent blok={blk} key={blk._uid} />
            ))
          : null}

        {settingsFooterProject.bloks.map((blk) => (
          <>
            <StoryblokComponent blok={blk} key={blk._uid} />
          </>
        ))}
      </main>
      <Footer settingsFooter={settingsFooter} />
      <GalleryOverlay bloks={blok.body} />
    </>
  );
};

export default Project;
